import React, { useState, useEffect } from 'react'
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd'
import styles from './index.less'
import { print } from "@/utils/printUtils"
import moment from 'moment'
import Common from '../../components/commonTable/commonShowComponent'

const { TextArea } = Input

const PrintModal = ({
  taskDetail = {},
  infos = {},
  type,
  visible,
  formType = 'default',
  ...other
}) => {
  const [info, setInfo] = useState({})

  useEffect(() => {
    if (infos) {
      setInfo({ ...infos })
    }
  }, [infos])

  const handleChange = (key, value) => {
   return 
  }

  return (
    <>
      {formType === 'default' ?
        <div id='printDetails'>
          <div className={styles.BSPPrint} id='printDetails'>
            <h2 className={'print-title'} style={{ textAlign: 'center' }}>心理服务完整表</h2>
            <div className={styles.headerDes}>
              <Descriptions bordered column={5}>
                <Descriptions.Item span={1} label="来访者姓名">{info.visitorName}</Descriptions.Item>
                <Descriptions.Item span={1} label="咨询师姓名">{info.consultantName}</Descriptions.Item>
                <Descriptions.Item span={1} label="日期时间">{info.documentDate && moment(info.documentDate).format('YYYY-MM-DD')}</Descriptions.Item>
                <Descriptions.Item span={1} className='noLabel'>第{info.count}次</Descriptions.Item>
                <Descriptions.Item span={1} className='noLabel'>共{info.totalCount}次</Descriptions.Item>
              </Descriptions>
            </div>
            <div className={styles.bspCommontContain}>
              <Descriptions bordered column={1}>
                {(info.stageConsultationGoal || info.thisTimeConsultationGoal) &&
                  <Descriptions.Item label="咨询目标">
                    <div className={styles.bspCommontContainChild}>
                      <Descriptions bordered column={1}>
                        {info.stageConsultationGoal &&
                          <Descriptions.Item label="本阶段"><div style={{ padding: '8px 16px' }}>{info.stageConsultationGoal}</div></Descriptions.Item>
                        }
                        {info.thisTimeConsultationGoal &&
                          <Descriptions.Item label="本次"><div style={{ padding: '8px 16px' }}>{info.thisTimeConsultationGoal}</div></Descriptions.Item>
                        }
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }

                {(info.homeworkCompletionStatus || info.changesAndReason || info.drugSideEffects || info.physiotherapy) &&
                  <Descriptions.Item label="咨询前回顾">
                    <div className={styles.bspCommontContainChild}>
                      <Descriptions bordered column={1}>
                        {info.homeworkCompletionStatus && <Descriptions.Item label="家庭作业完成情况">
                          <div style={{ padding: '8px 16px' }}>
                            <TextArea value={info.homeworkCompletionStatus} autoSize={{ minRows: 1 }} onChange={e => handleChange('homeworkCompletionStatus', e.target.value)} />
                          </div>
                        </Descriptions.Item>}
                        {info.changesAndReason && <Descriptions.Item label="已发生的好/坏改变，为何改变">
                          <div style={{ padding: '8px 16px' }}>
                            <TextArea value={info.changesAndReason} autoSize={{ minRows: 1 }} onChange={e => handleChange('changesAndReason', e.target.value)} />
                          </div>
                        </Descriptions.Item>}
                        {info.drugSideEffects && <Descriptions.Item label="药物副作用和依从性等">
                          <div style={{ padding: '8px 16px' }}>
                            <TextArea value={info.drugSideEffects} autoSize={{ minRows: 1 }} onChange={e => handleChange('drugSideEffects', e.target.value)} />
                          </div>
                        </Descriptions.Item>}
                        {info.physiotherapy && <Descriptions.Item label="物理治疗">
                          <div style={{ padding: '8px 16px' }}>
                            <TextArea value={info.physiotherapy} autoSize={{ minRows: 1 }} onChange={e => handleChange('physiotherapy', e.target.value)} />
                          </div>
                        </Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
                {(info.thisConsultationStep || info.thisCoreTechnology || info.coreConversationRecord || info.thisNewDiscoveryAndHarvest || info.thisNewDiscoveryAndHarvest || info.difficultiesAndBreakthroughsInConsultation) &&
                  <Descriptions.Item label="咨询过程记录">
                    <div className={styles.bspCommontContainChild}>
                      <Descriptions bordered column={1}>
                        {info.thisConsultationStep && <Descriptions.Item label="本次咨询步骤">
                          <div style={{ padding: '8px 16px' }}>
                            <TextArea value={info.thisConsultationStep} autoSize={{ minRows: 1 }} onChange={e => handleChange('thisConsultationStep', e.target.value)} />
                          </div>
                        </Descriptions.Item>}
                        {info.thisCoreTechnology && <Descriptions.Item label="本次核心技术"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.thisCoreTechnology} autoSize={{ minRows: 1 }} onChange={e => handleChange('thisCoreTechnology', e.target.value)} />
                        </div>
                        </Descriptions.Item>}
                        {info.coreConversationRecord && <Descriptions.Item label="核心对话记录"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.coreConversationRecord} autoSize={{ minRows: 1 }} onChange={e => handleChange('coreConversationRecord', e.target.value)} />
                        </div></Descriptions.Item>}
                        {info.thisNewDiscoveryAndHarvest && <Descriptions.Item label="本次的新发现与收获"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.thisNewDiscoveryAndHarvest} autoSize={{ minRows: 1 }} onChange={e => handleChange('thisNewDiscoveryAndHarvest', e.target.value)} />
                        </div></Descriptions.Item>}
                        {info.thisNewDiscoveryAndHarvest && <Descriptions.Item label="核心症状改变情况"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.changesInCoreSymptoms} autoSize={{ minRows: 1 }} onChange={e => handleChange('changesInCoreSymptoms', e.target.value)} />
                        </div></Descriptions.Item>}
                        {info.difficultiesAndBreakthroughsInConsultation && <Descriptions.Item label="咨询中的难点和待突破点"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.difficultiesAndBreakthroughsInConsultation} autoSize={{ minRows: 1 }} onChange={e => handleChange('difficultiesAndBreakthroughsInConsultation', e.target.value)} />
                        </div></Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
                {(info.communicationRecordWithFamilyGuardian || info.communicationRecordWithPhysicianAndSoOn || info.communicationRecordWithSupervisorAndSoOn) &&
                  <Descriptions.Item label="关键人沟通记录">
                    <div className={styles.bspCommontContainChild}>
                      <Descriptions bordered column={1}>
                        {info.communicationRecordWithFamilyGuardian && <Descriptions.Item label="与家属监护人"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.communicationRecordWithFamilyGuardian} autoSize={{ minRows: 1 }} onChange={e => handleChange('communicationRecordWithFamilyGuardian', e.target.value)} />
                        </div></Descriptions.Item>}
                        {info.communicationRecordWithPhysicianAndSoOn && <Descriptions.Item label="与医师、物理治疗师、私人管家等"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.communicationRecordWithPhysicianAndSoOn} autoSize={{ minRows: 1 }} onChange={e => handleChange('communicationRecordWithPhysicianAndSoOn', e.target.value)} />
                        </div></Descriptions.Item>}
                        {info.communicationRecordWithSupervisorAndSoOn && <Descriptions.Item label="与督导等人"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.communicationRecordWithSupervisorAndSoOn} autoSize={{ minRows: 1 }} onChange={e => handleChange('communicationRecordWithSupervisorAndSoOn', e.target.value)} />
                        </div></Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
                {info.prescriptionsAndHomework && <Descriptions.Item label="处方和家庭作业(包括居家心理训练和心理教练)"><div style={{ padding: '8px 16px' }}>
                  <TextArea value={info.prescriptionsAndHomework} autoSize={{ minRows: 1 }} onChange={e => handleChange('prescriptionsAndHomework', e.target.value)} />
                </div></Descriptions.Item>}

                {(info.possibilityOfShedding || info.possibilityOfSheddingComment || info.potentialCausesOfShedding || info.potentialCausesOfSheddingComment || info.supplementaryDescriptionOfShedding) &&
                  <Descriptions.Item label="对脱离的预判">
                    <div className={styles.bspCommontContainChild}>
                      <Descriptions bordered column={1}>
                        {(info.possibilityOfShedding || info.possibilityOfSheddingComment) && <Descriptions.Item label="可能性">
                          <div className={styles.bspCommontContainChild2} style={{ borderTop: '1px solid #e8e8e8' }}>
                            <Descriptions bordered column={1}>
                              {info.possibilityOfShedding && <Descriptions.Item><div style={{ padding: '8px 16px', minHeight: 34 }}>{info.possibilityOfShedding}</div></Descriptions.Item>}
                              {info.possibilityOfSheddingComment && <Descriptions.Item><div style={{ padding: '8px 16px', minHeight: 34 }}>其他备注：{info.possibilityOfSheddingComment}</div></Descriptions.Item>}
                            </Descriptions>
                          </div>
                        </Descriptions.Item>}
                        {(info.potentialCausesOfShedding || info.potentialCausesOfSheddingComment) && <Descriptions.Item label="潜在原因">
                          <div className={styles.bspCommontContainChild2} style={{ borderTop: '1px solid #e8e8e8' }}>
                            <Descriptions bordered column={1}>
                              {info.potentialCausesOfShedding && <Descriptions.Item><div style={{ padding: '8px 16px', minHeight: 34 }}>{info.potentialCausesOfShedding}</div></Descriptions.Item>}
                              {info.potentialCausesOfSheddingComment && <Descriptions.Item><div style={{ padding: '8px 16px', minHeight: 34 }}>其他备注：{info.potentialCausesOfSheddingComment}</div></Descriptions.Item>}
                            </Descriptions>
                          </div>
                        </Descriptions.Item>}
                        {info.supplementaryDescriptionOfShedding && <Descriptions.Item label="补充描述"><div style={{ padding: '8px 16px' }}>
                          <TextArea value={info.supplementaryDescriptionOfShedding} autoSize={{ minRows: 1 }} onChange={e => handleChange('supplementaryDescriptionOfShedding', e.target.value)} />
                        </div></Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </Descriptions.Item>
                }
              </Descriptions>
            </div>
          </div>
        </div>
        : <Common result={info} />}
    </>
  )
}

export default Form.create()(PrintModal)
